import { useState } from "react";

import { useAppStore } from "../store/appStore";
import { FormControl, FormHelperText, LinearProgress, TextField } from "@mui/material";
import {
  Controller,
  useController,
  UseControllerReturn,
  useFormContext,
} from "react-hook-form";
import { verifyEmail } from "../service/emailVerifier";

export interface EmailInputProps {
  name: string;
  placeholder?: string;
  label?: string;
  preventPaste?: boolean
  type?: string
  readonly?: boolean
}

// perlajons95@gmail.com has full inbox
export const EmailInput = (props: EmailInputProps) => {
  const setHideSubmit = useAppStore(state => state.setHideSubmit)
  const [verif, setVerif] = useState({ error: false, message: "" });
  const [progress, setProgress] = useState(false);
  const { control } = useFormContext();

  const controller: UseControllerReturn = useController({
    name: props.name,
    control,
  });
  
  const handleOnBlur = (emailToCheck: EmailInputProps) => {
    if (props.readonly) return
    setHideSubmit(true)
    // console.log('checking', emailToCheck)
    // console.log('field', controller.field.name)
    if (!emailToCheck) {
      return
    }
    setProgress(true)
    verifyEmail(emailToCheck)
      .then(data => {
        setVerif(data)
        setProgress(false)
        if (!data.error) {
          setHideSubmit(false)
        }
      })
  }

  
  const handleKeyDown = () => {
    if (props.readonly) return
    setVerif({ error: false, message: "" })
    setProgress(false)
    setHideSubmit(false)
  }
  
  


  return (
    <Controller
      name="name"
      control={control}
      defaultValue=""
      render={({ field: { value, onChange, ...field } }) => (
        <>
          <FormControl fullWidth 
          onBlur={() => { handleOnBlur(controller.field.value) }}
          onKeyDown={() => { handleKeyDown() }}
          >

            <TextField
              {...field}
              type={props.type || "text"}
              sx={{
                "& .MuiFormLabel-root": {
                  fontSize: '0.9em'
                },
                "& .MuiInputBase-root": {
                  fontSize: '0.9em', height: 35
                }
              }}
              variant="outlined"
              size="small"
              placeholder={props.placeholder}
              label={props.label}
              onChange={controller.field.onChange}
              onBlur={controller.field.onBlur}
              name={controller.field.name}
              value={controller.field.value || ""}
              ref={controller.field.ref}
              error={!!controller.fieldState.error || progress || verif.error}
              helperText={controller.fieldState.error?.message}
              inputProps={{readOnly: props.readonly}}
            />
            {verif.message !== "" && <FormHelperText sx={{ ml: 2 }} error={verif?.error ? true : false}>
              {verif.message}
            </FormHelperText>}
          </FormControl>
          {progress && <LinearProgress sx={{ height: 0.05 }} color="inherit" />}
        </>
      )}
    />
  );
};
